import React, { useState } from "react";
import { useFunctions } from "reactfire";
import { useUser } from "reactfire";
import { httpsCallable } from "firebase/functions";
import { IonButton } from "@ionic/react";
import { useHistory } from "react-router-dom";

const GeneralMessage = ({ message, menuRef }) => {
  const functions = useFunctions();
  const { status, data: user } = useUser();
  const [declineIsLoading, setDeclineIsLoading] = useState(false);
  const history = useHistory();

  const deleteMessage = httpsCallable(functions, "deleteMessage", {
    timeout: 530000,
  });

  const callDeclineLeague = async (e) => {
    e.preventDefault();
    setDeclineIsLoading(true);

    let data = {
      userId: user.uid,
      messageId: message.id,
    };

    try {
      await deleteMessage(data);
      setDeclineIsLoading(false);
    } catch (error) {
      console.log(error);
      setDeclineIsLoading(false);
    }
  };

  return (
    <>
      <div className="flex text-xs pb-2">{message?.title}:</div>
      <div className="flex text-xs pb-2">{message?.body}</div>
      <IonButton
        mode="ios"
        fill="outline"
        disabled={declineIsLoading}
        onClick={(e) => callDeclineLeague(e)}
        className="m-0 h-8 customButtonNew"
      >
        Remove
      </IonButton>

      {message?.url && (
        <IonButton
          mode="ios"
          color="success"
          onClick={() => {
            menuRef?.current?.close();
            history.push("/tutorial");
          }}
          routerLink={message?.url}
          fill="filled"
          className="m-0 h-8 customButtonNew"
        >
          Open
        </IonButton>
      )}
    </>
  );
};

export default GeneralMessage;
